import { createServerFn } from "@tanstack/react-start";

export type MonitoringConfig = {
  dsn: string | null;
  environment: string;
  release: string | null;
  tracesSampleRate: number;
};

/**
 * Exposes the (public) Sentry DSN to the browser without baking it into the bundle.
 * Returns dsn: null when no DSN secret is configured — monitoring then stays disabled.
 */
export const getMonitoringConfig = createServerFn({ method: "GET" }).handler(
  async (): Promise<MonitoringConfig> => {
    const dsn = process.env.SENTRY_DSN ?? process.env.VITE_SENTRY_DSN ?? null;
    const environment =
      process.env.SENTRY_ENVIRONMENT ??
      (process.env.NODE_ENV === "production" ? "production" : "development");
    const release = process.env.SENTRY_RELEASE ?? null;
    const rate = Number(process.env.SENTRY_TRACES_SAMPLE_RATE ?? "0.1");

    return {
      dsn: dsn && dsn.trim() !== "" ? dsn.trim() : null,
      environment,
      release,
      tracesSampleRate: Number.isFinite(rate) ? Math.min(Math.max(rate, 0), 1) : 0.1,
    };
  },
);
